import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "../../../common/analytics";

const RouteAnalytics = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    trackPageView(`${pathname}${search}${hash}`);
  }, [hash, pathname, search]);

  return null;
};

export default RouteAnalytics;
